import { ResourcesConfig } from 'aws-amplify';
import { AmplifyOutputs, LegacyConfig } from 'aws-amplify/adapter-core';

export default {
  API: {
    GraphQL: {
      region: 'ap-southeast-2',
      endpoint: import.meta.env.VITE_AMPLIFY_ENDPOINT,
      defaultAuthMode: 'identityPool'
    }
  },
  Auth: {
    Cognito: {
      identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID,
      allowGuestAccess: true
    }
  }
} satisfies ResourcesConfig | LegacyConfig | AmplifyOutputs;
